//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerSearch from  '../components/header-search'
import contactUs from '../components/contact-us'

import { Toast } from 'vant'
import instance from '../assets/js/instance'


export default {
  data () {
    return {
      info: {
        brand_img: '',
        brand_name: '',
        company_img: ''
      },
      baseUrl: process.env.BASE_URL,
      id: 1,
      pull: false,
      page: 1,
      list: [],
      default: [
      ],
      min: true,
      showContact: false
    }
  },
  computed: {
    options () {
      return this.$t('products')
    },
    path () {
      return this.$store.getters.getPath
    },

    cMenu() {
      return this.$t("cMenu");
    },

    isPhone() {
      return this.$store.getters.getIsPhone;
    }
  },
  components: {
    headerSearch,
    contactUs
  },
  methods: {
    getList () {
      this.showToast()
      instance(`/api/goods/getGoods?p=${this.page}&brand_id=${this.id}`).then(res => {
        let data = res.data
        if (data.code === 0) {
          this.list = this.list.concat(data.data.list)
        }
        this.pull = false
        this.clearToast()
      }).catch(e => {
        console.log(e)
        this.pull = false
        this.clearToast()
      })
    },

     showToast () {
      Toast.loading({
        duration: 0,
        mask: true,
        message: this.options.loading
      })
    },

    clearToast () {
      Toast.clear()
    },

    go (id) {
      this.$router.push(`${this.path}/detail?id=${id}`)
    },
    
    refresh () {
      this.page = 1
      this.list = []
      this.getList()
    },

    getInfo () {
      instance.get('/api/brand/getBrandDetail?id=' + this.id).then(res => {
        let data = res.data
        if (data.code === 0) {
          this.info = data.data
        }
      }).catch(e => {
        console.log(e)
      })
    },

    showTact () {
      this.showContact = true
    },

    closeTact () {
      this.showContact = false
    },

    init () {
      if (!instance.defaults.headers.language) {
        return false
      }
      let id = ''
      if (this.$route.query.id) {
        id = this.$route.query.id
      }
      this.id = id
      this.getInfo()
      this.getList()
    }
  },
  mounted () {
    this.init()
    window.subscribe.listen('languageChange', () => {
      this.init()
    })
  }
}
